import React from 'react';

const InfoItem = ({ title, value, icon }) => {
  return (
    <>
      <div className='row main-info__item'>
        <div className='col'>
          <i className={`fas fa-${icon}`}></i>
          <span className='fa5-text'>{title}</span>
        </div>
        <div className='col'>
          <strong>
            {value}
          </strong>
        </div>
      </div>
    </>
  );
}

export default InfoItem;